const maptiler = {
    apiKey:"2UMfYavnCGXxudekJQam",
    attribution:'<a href="https://www.maptiler.com/copyright/" target="_blank">&copy; MapTiler</a> <a href="https://www.openstreetmap.org/copyright" target="_blank">&copy; OpenStreetMap contributors</a>'
}
export default maptiler;